module.exports = __webpack_public_path__ + "static/media/reports.339e6021.svg";